import { PortfolioExportJobSchema } from "@/tools/aggregate/portfolio-export/types";

export const getAssetsDone = (schema: PortfolioExportJobSchema): boolean =>
  schema.assets.totalCount > 0 && schema.assets.processedCount + schema.assets.errorCount >= schema.assets.totalCount;

export const getHasAdaptationPhase = (schema: PortfolioExportJobSchema, canRunAutoAdaptation: boolean): boolean =>
  canRunAutoAdaptation && schema.autoAdaptationStatus !== null;

export const getAdaptationsDone = (schema: PortfolioExportJobSchema, canRunAutoAdaptation: boolean): boolean => {
  if (!getHasAdaptationPhase(schema, canRunAutoAdaptation)) return true;
  if (schema.autoAdaptationStatus === "completed") return true;

  const adaptations = schema.adaptations;
  return (
    !!adaptations &&
    adaptations.totalCount > 0 &&
    adaptations.processedCount + adaptations.errorCount >= adaptations.totalCount
  );
};

export const getIsAdaptationProcessing = (schema: PortfolioExportJobSchema, canRunAutoAdaptation: boolean): boolean =>
  getHasAdaptationPhase(schema, canRunAutoAdaptation) && !getAdaptationsDone(schema, canRunAutoAdaptation);

/** Eligibility for a re-process; the analysis list row and the collection page must agree on it. */
export const getCanReprocessForAdaptations = (
  schema: PortfolioExportJobSchema,
  canRunAutoAdaptation: boolean
): boolean =>
  canRunAutoAdaptation &&
  ["completed", "completed_with_errors"].includes(schema.status) &&
  schema.updateAvailable &&
  schema.autoAdaptationStatus === null &&
  schema.assets.processedCount > 0;

// both asset and adaptation processing complete
export const getAnalysisComplete = (schema: PortfolioExportJobSchema, canRunAutoAdaptation: boolean): boolean =>
  (schema.status === "completed" || schema.status === "completed_with_errors") &&
  getAssetsDone(schema) &&
  getAdaptationsDone(schema, canRunAutoAdaptation);
